import request from '@/utils/request'

/**
 * 未读消息分页列表
 * @param param
 */
export const unnoticeList = (params) => {
  return request({
    url: '/sol/personal/message/list',
    method: 'GET',
    params
  })
}
/**
 * 标记未读消息为已读
 * @param param
 */
export const readmsg = (params) => {
  return request({
    url: '/sol/personal/message/readmsg',
    method: 'GET',
    params
  })
}
/**
 * 删除消息
 * @param param
 */
export const deleteNotice = (params) => {
  return request({
    url: '/sol/personal/message/delete',
    method: 'DELETE',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/notice/notice.js